enum CameraConfig {
    CameraSpeed = 1,
    RotationSpeed = 0.005,
  }
  
export { CameraConfig };
